import { Component } from '@angular/core';
import { BaseFormControlComponent } from '../base-form-control.component';
import { BaseEntity } from '../../base-entity/base-entity';
import { NgClass } from '@angular/common';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'base-textarea',
  standalone: true,
  templateUrl: './textarea.component.html',
  imports: [NgClass, MatFormField, MatInput, MatLabel, ReactiveFormsModule],
  styles: [
    `
      :host {
        display: block;
      }
      .full-width {
        width: 100%;
      }
    `,
  ],
})
export class TextareaComponent<Entity extends BaseEntity> extends BaseFormControlComponent<Entity> {}
